import Notification from '../components/common/Notification';
import IStoreState from "../store/IStoreState";

const defaultState: IStoreState = {
  notifications: [] as Notification[],
};

export default defaultState;



// WEBPACK FOOTER //
// ./src/reducers/notificationsInitialState.ts